import React, { Component } from 'react';
import Session, { session } from "services/session";
import ApiHelper from "services/api-helper";
import { Button, Modal, Form } from "semantic-ui-react";
import toastr from 'toastr'

class Header extends Component {
  state = { openModal: false }

  logout = () => {
    Session.removeSession();
    ApiHelper.Post('/api/logout').then(() => {
      window.location.href = "/login"
    })
  }

  changePasswordModal = () => {
    this.setState({ openModal: true })
  }

  updateModalState = (openModal) => {
    this.setState({ openModal })
  }

  getHoTen() {
    return session.HoTen ? session.HoTen : session.UserName ? session.UserName : 'undefined'
  }

  render() {
    return (
      <header className="app-header navbar">
        <button className="navbar-toggler sidebar-toggler d-lg-none mr-auto" type="button" data-toggle="sidebar-show">
          <span className="navbar-toggler-icon"></span>
        </button>
        <a className="navbar-brand" href="/">
          <img className="navbar-brand-full" src="img/logoPSC.png" height="47" alt="CoreUI Logo" />
          <img className="navbar-brand-minimized" src='img/favicon.ico' width="30" height="30" alt="CoreUI Logo" />
        </a>
        <button className="navbar-toggler sidebar-toggler d-md-down-none" type="button" data-toggle="sidebar-lg-show">
          <span className="navbar-toggler-icon"></span>
        </button>
        <ul className="nav navbar-nav ml-auto">
          {/* <li className="nav-item d-md-down-none">
            <a className="nav-link" href="">
              <i className="icon-bell"></i>
              <span className="badge badge-pill badge-danger">5</span>
            </a>
          </li> */}
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="" role="button" aria-haspopup="true" aria-expanded="false">
              {/* <img className="img-avatar" src="img/avatars/6.jpg" alt="admin@bootstrapmaster.com" /> */}
              <span>{this.getHoTen()}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {/* <div className="dropdown-header text-center">
                <strong>Account</strong>
              </div>
              <a className="dropdown-item" href="">
                <i className="fa fa-bell-o"></i>Updates
              <span className="badge badge-info">42</span>
              </a>
              <a className="dropdown-item" href="">
                <i className="fa fa-envelope-o"></i>Messages
              <span className="badge badge-success">42</span>
              </a>
              <a className="dropdown-item" href="">
                <i className="fa fa-tasks"></i>Tasks
              <span className="badge badge-danger">42</span>
              </a>
              <a className="dropdown-item" href="">
                <i className="fa fa-comments"></i>Comments
              <span className="badge badge-warning">42</span>
              </a>
              <div className="dropdown-header text-center">
                <strong>Settings</strong>
              </div>
              <a className="dropdown-item" href="">
                <i className="fa fa-user"></i>Profile</a>
              <a className="dropdown-item" href="">
                <i className="fa fa-wrench"></i>Settings</a>
              <a className="dropdown-item" href="">
                <i className="fa fa-usd"></i>Payments
              <span className="badge badge-secondary">42</span>
              </a>
              <a className="dropdown-item" href="">
                <i className="fa fa-file"></i>Projects
              <span className="badge badge-primary">42</span>
              </a>
              <div className="divider"></div> */}
              <a className="dropdown-item" onClick={() => this.updateModalState(true)}>
                <i className="fa fa-shield"></i>Đổi mật khẩu</a>
              <a className="dropdown-item" onClick={this.logout}>
                <i className="fa fa-lock"></i>Đăng xuất</a>
            </div>
          </li>
        </ul>
        <button className="navbar-toggler aside-menu-toggler d-md-down-none" type="button" data-toggle="aside-menu-lg-show">
          <span className="navbar-toggler-icon"></span>
        </button>
        <button className="navbar-toggler aside-menu-toggler d-lg-none" type="button" data-toggle="aside-menu-show">
          <span className="navbar-toggler-icon"></span>
        </button>
        <ChangePasswordModal openModal={this.state.openModal} closeModal={() => this.updateModalState(false)} />
      </header>
    )
  }
}

class ChangePasswordModal extends Component {
  changePassword = () => {
    if (this.refs.passwordConfirm.value !== this.refs.password.value) {
      toastr.error('Mật khẩu nhập lại không khớp')
      return;
    }
    ApiHelper.PostJson('api/doiMatKhau', {
      Oid: session.WebUserId,
      OldPassword: this.refs.oldPassword.value,
      Password: this.refs.password.value
    }).then(res => {
      if (res === 1) {
        toastr.success('Đổi mật khẩu thành công!')
        this.props.closeModal()
      }
      else if (res === 2)
        toastr.error('Mật khẩu cũ không chính xác!')
      else if (res === 0)
        toastr.error('Lỗi!')
    })
  }
  render() {
    return (
      <Modal
        open={this.props.openModal}
        onClose={this.props.closeModal}
        size="tiny"
      >
        <Modal.Header>Đổi mật khẩu tài khoản</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>Mật khẩu hiện tại</label>
              <input type="password" ref="oldPassword" />
            </Form.Field>
            <Form.Field>
              <label>Mật khẩu mới</label>
              <input type="password" ref="password" />
            </Form.Field>
            <Form.Field>
              <label>Nhập lại mật khẩu mới</label>
              <input type="password" ref="passwordConfirm" />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.closeModal} negative>
            Hủy
            </Button>
          <Button
            onClick={this.changePassword}
            positive
            labelPosition='right'
            icon='checkmark'
            content='Lưu'
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/layout/header.jsx